export const REGEX = {
  email: /^[+\w-.]+@([+\w-]+\.)+[+\w-]{2,4}$/,
  password: /^[^\n]{8,}$/,
  mfaCode: /^[0-9]{6}$/,
  phone: /^[0-9]{10}$/,
  paymentReference: /^(?=^[A-Za-z0-9. &]{6,18}$)(?!^(.)\1*$).*$/,
  name: /^(?=^[A-Za-z]{2,45}$)(?!^(.)\1*$).*$/
};
